import React from 'react';
import { Item } from './Item';
import { XLCardProps } from 'types/CardComponents';

export const XLCard = ({ 
    results, 
    hasActions,
    withImg,
    rowClicked,
    className,
    headers,
}: XLCardProps) => {
    return (
        <div className="table-container is-card card-container">
            {results.map((card, card_index) =>
                <Item 
                    key={card_index} 
                    card={card}
                    card_index={card_index}
                    hasActions={hasActions}
                    withImg={withImg}
                    rowClicked={rowClicked}
                    className={className}
                    headers={headers}
                />,
            )}
        </div>
    );
};